<div class="container-fluid InfoForm thin-scroll">
    <div class="header  my-2 d-flex align-items-center justify-content-between p-1">
        <h6 class="m-0"><span class="headertxt"> Company & Contact Information : </span></h6>
        <button
        (click)="showEditMode()"
        class="previewbtn text-center btn float-right"
        *ngIf="canChange"
    >
    <img src="../../../../../assets/shoppingCart/edit.png"
    class="imgIcon" />
    <span class="mx-1 text-white"> Edit</span>

    </button>
    </div>
    <hr class="" />
    <div class="pr-3">
        <div class="row ml-1">
            <app-contact 
                class="w-100" [isCreateOrEdit]="isCreateOrEdit" [activeTab]="activeTab"
                [currentTab]="currentTab"
                    [appTransactionsForViewDto]="appTransactionsForViewDto"
                    (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                    [showDepartment]="activeTab ==transactionCartoccordionTabs.BuyerContactInfo"
                    (formValidityChanged)="isContactFormValid($event)"></app-contact>
        </div>
    </div>
    <hr class="my-2" />
</div>